import React from 'react';
import { connect } from 'react-redux';
import { bool, number, func, string } from 'prop-types';
import { createSelector } from 'reselect';
import { isEmpty } from '@widergy/web-utils/lib/array';

import { referenceType, officesType } from 'types/turnsTypes';
import { message } from 'utils/stringUtils';

import GridWrapper from '../../../components/GridWrapper';
import CardError from '../CardError';

import CardOffice from './components/CardOffice';
import styles from './styles.module.scss';

const Offices = ({
  refOffices,
  currentForm,
  currentOffice,
  handleSetOffice,
  officesLoading,
  offices,
  officesError,
  reload
}) => {
  const handleRenderOffice = item => (
    <CardOffice {...item} selected={item.id === currentOffice} onClick={handleSetOffice} />
  );

  return (
    <GridWrapper
      reference={refOffices}
      loading={officesLoading}
      title={message('Turns:selectOffice')}
      hasElements={!officesError}
      className={!currentForm && styles.hidden}
    >
      {offices && offices.map(handleRenderOffice)}
      {officesError && <CardError error={officesError} buttonFunction={reload} />}
    </GridWrapper>
  );
};

Offices.propTypes = {
  refOffices: referenceType,
  currentOffice: number,
  currentForm: bool,
  handleSetOffice: func.isRequired,
  officesLoading: bool,
  offices: officesType,
  officesError: string,
  reload: func
};

const officesSelector = createSelector(
  store => store.utility.commercialOffices,
  commercialOffices => {
    if (isEmpty(commercialOffices) || isEmpty(commercialOffices.offices)) return null;
    return commercialOffices.offices.map(office => ({
      id: office.id,
      address: office.address,
      name: office.name
    }));
  }
);

const mapStateToProps = store => ({
  offices: officesSelector(store),
  officesLoading: store.utility.commercialOfficesLoading,
  officesError: store.utility.commercialOfficesError
});

export default connect(mapStateToProps)(Offices);
